var version = {
    "name":      "dativery",
    "buildDateCode": "20260424-101046",
    "buildDate": "Fri Apr 24 2026 10:10:46 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260424-101046",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;